@if ((dataSource().loading$ | async) === 'initial') {
<div class="table-container mat-elevation-z2">
  <lib-skeleton-table-loader />
</div>
} @else {
@if ((dataSource().loading$ | async) === 'subsequent') {
<mat-progress-bar mode="indeterminate" />
}

<div class="table-container mat-elevation-z2">

  <table mat-table
         [dataSource]="currentItems()"
         matSort
         [matSortActive]="defaultSort()"
         [matSortDirection]="defaultSortDirection()"
         (matSortChange)="onSort($event)">

    @if (selectionMode() !== 'none') {

    <ng-container matColumnDef="select">

      <th mat-header-cell
          *matHeaderCellDef>
        @if (selectionMode() === 'multi') {
        <mat-checkbox [checked]="isAllSelected()"
                      [indeterminate]="isIndeterminate()"
                      (change)="onMasterCheckboxChange()" />
        }
      </th>

      <td mat-cell
          *matCellDef="let row">
        <mat-checkbox [checked]="isSelected(row)"
                      (change)="onCheckboxChange(row)"
                      (click)="$event.stopPropagation()" />
      </td>
    </ng-container>
    }

    @for (col of columns(); track col.memberName) {
    @if (!col.isDisabled && col.isVisible !== false) {

    <ng-container [matColumnDef]="col.memberName"
                  [sticky]="col.sticky ?? false"
                  [stickyEnd]="col.stickyEnd ?? false">

      <th mat-header-cell
          *matHeaderCellDef
          [mat-sort-header]="col.sortMemberName ?? col.memberName"
          [disabled]="!col.sortable">
        @if (col.headerTemplate) {

        <ng-container *ngTemplateOutlet="col.headerTemplate; context: { column: col }" />
        } @else if (!col.hideHeading) {
        {{ col.title }}
        }
      </th>

      <td mat-cell
          *matCellDef="let row">
        @if (col.template) {

        <ng-container *ngTemplateOutlet="col.template; context: { $implicit: row, column: col }" />
        } @else {
        {{ row[col.memberName] }}
        }
      </td>
    </ng-container>
    }
    }

    <tr mat-header-row
        *matHeaderRowDef="displayedColumns(); sticky: stickyHeader()"></tr>

    <tr mat-row
        *matRowDef="let row; columns: displayedColumns();"
        [class.clickable-row]="rowClickable()"
        [class.selected-row]="isSelected(row)"
        (click)="onRowClick(row)"
        (dblclick)="onRowDoubleClick(row)"></tr>

    <tr class="mat-row no-data-row"
        *matNoDataRow>

      <td class="mat-cell"
          [attr.colspan]="displayedColumns().length">
        {{ noDataMessage() }}
      </td>
    </tr>
  </table>
</div>

@if (showPaginator()) {
<mat-paginator [length]="(dataSource().itemCount$ | async) ?? 0"
               [pageSize]="pageSize()"
               [pageSizeOptions]="pageSizeOptions()"
               showFirstLastButtons
               (page)="onPage($event)" />
}
}